//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type } from '../genericFlowTypes'
import type { EditFormData,PostPayloadData  } from './flowTypes'

export const getTaskData=(phobos:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,'Phobos',taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.PHOBOS_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,phobos)
            dispatch({
                type: actionTypes.PHOBOS_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.PHOBOS_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.PHOBOS_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,phobosResultset:any,phobos:ReducerState$Type)=>{
    let payload:PostPayloadData={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (phobosResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=phobosResultset.vendorName;
        payload.invNo=phobosResultset.invNo;
        payload.invDate=phobosResultset.invDate;
        payload.serviceAddr=phobosResultset.serviceAddr;
        payload.total=phobosResultset.total;
        payload.isInvalidDoc=phobosResultset.isInvalidDoc?phobosResultset.isInvalidDoc:false;
        payload.poNo=phobosResultset.poNo?phobosResultset.poNo:'';
        payload.isOverrideVendorName=phobosResultset.isOverrideVendorName?phobosResultset.isOverrideVendorName:false;
    }

    if (phobos.reviewQuestions && phobos.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(phobosResultset,phobos.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.PHOBOS_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.PHOBOS_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.PHOBOS_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.PHOBOS_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsApi(jwt,'Phobos').then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_PHOBOS_VENDORS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_PHOBOS_VENDORS_SUCCESS, vendors: data.vendors });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_PHOBOS_VENDORS_ERROR, error: err});
    })
}


// WEBPACK FOOTER //
// ./src/redux/phobos/actions.js